import { useContext } from 'react';

import { SignInContext, TUser, USER_GROUPS } from '@modules/users';

import { AccessType } from '../types';

type TCanEditOptions = { authorGroup?: boolean };

// For a callback that cannot call a hook, such as an action built per row.
export const getCanEdit = (
  user: Pick<TUser, 'groups' | 'license'>,
  accessRight: AccessType,
  { authorGroup = true }: TCanEditOptions = {}
) => {
  const hasEditAccess = accessRight >= AccessType.EDIT;
  const isInAuthorGroup = !authorGroup || user.groups.includes(USER_GROUPS.AUTHOR);
  const hasFullLicense = user.license === 'FULL';
  const canEdit = hasEditAccess && isInAuthorGroup && hasFullLicense;
  const editLockedReason = !hasEditAccess
    ? "You don't have edit access."
    : !isInAuthorGroup
      ? 'Author role required.'
      : !hasFullLicense
        ? 'Full license required.'
        : '';
  return { canEdit, editLockedReason };
};

export const useCanEdit = (accessRight: AccessType, options: TCanEditOptions = {}) => {
  const { user } = useContext(SignInContext);
  return getCanEdit(user, accessRight, options);
};
